export default __webpack_public_path__ + "static/media/empty-cart.916aede4.svg";